import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

import { LoyaltyLoader } from '../loyalty-loader';

export const StyledLoyaltyLoader = LoyaltyLoader;

export const OffersCooldownContainer = Box.withConfig({
  backgroundColor: primitive.$warningLight,
  paddingY: '$2',
});

export const CooldownMessageContainer = Box.withConfig({
  flexDirection: 'column',
});

export const OffersCooldownTitle = withTypography({
  variant: 'headerFour',
  fontSize: 'xs',
  mb: '$0',
});

export const OffersCooldownMessage = withTypography({ variant: 'copyTwo', fontSize: 'xs' });
